import ctl from '@netlify/classnames-template-literals'
import { ReactNode } from 'react'

export type TableProps = {
	children: ReactNode
	head?: ReactNode
}

export function Table({ children, head }: TableProps) {
	const className = ctl(`
		w-full divide-y-[1px] 
		overflow-auto border-t 
		
		divide-grey-100
		dark:divide-grey-800
		dark:border-t-grey-800 
		border-t-grey-100
	`)

	return (
		<table className={className}>
			{head
				? (
					<thead>
						{head}
					</thead>
				)
				: null}
			<tbody>
				{children}
			</tbody>
		</table>
	)
}
